import cx from "classnames";
import React, { ElementType, ReactNode } from "react";

import styles from "./styles.module.css";

export type PaddingWrapperProps = {
  as?: ElementType;
  clearMenu?: boolean;
  restrictInnerWidth?: boolean;
  disable?: boolean;
  children: ReactNode;
  className?: string;
} & (
  | {
      onlyX?: boolean;
      onlyY?: never;
    }
  | {
      onlyX?: never;
      onlyY?: boolean;
    }
);

export const PaddingWrapper = ({
  as: Root = "div",
  clearMenu,
  restrictInnerWidth,
  onlyX,
  onlyY,
  disable,
  children,
  className,
}: PaddingWrapperProps) => {
  if (disable) {
    return <Root className={className}>{children}</Root>;
  }
  return (
    <Root
      className={cx(
        styles.paddingWrapper,
        { [styles.onlyX]: onlyX },
        { [styles.onlyY]: onlyY },
        { [styles.allDimensions]: !onlyX && !onlyY },
        { [styles.clearMenu]: clearMenu },
        { [styles.restrictInnerWidth]: restrictInnerWidth },
        className
      )}
    >
      {children}
    </Root>
  );
};
